<template>
  <div v-if="hasError" class="error-boundary">
    <h2>糟糕，出现了一些问题</h2>
    <p>{{ errorMessage }}</p>
    <button @click="resetError" class="retry-btn">重试</button>
  </div>
  <slot v-else></slot>
</template>

<script>
export default {
  name: 'ErrorBoundary',
  data() {
    return {
      hasError: false,
      errorMessage: ''
    };
  },
  errorCaptured(err, vm, info) {
    // 处理错误
    this.hasError = true;
    this.errorMessage = err.message || '未知错误';
    
    // 记录错误到控制台
    console.error('Error captured by boundary:', err, info);
    
    // 返回false以阻止错误继续传播
    return false;
  },
  methods: {
    resetError() {
      this.hasError = false;
      this.errorMessage = '';
    }
  }
};
</script>

<style scoped>
.error-boundary {
  text-align: center;
  padding: 2rem;
  background: rgba(255, 69, 69, 0.2);
  border-radius: 10px;
  border: 1px solid rgba(255, 69, 69, 0.5);
  margin: 1rem;
}

.error-boundary h2 {
  color: #ff4545;
  margin-bottom: 1rem;
}

.error-boundary p {
  color: #ff9999;
  margin-bottom: 1rem;
}

.retry-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 50px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  font-weight: bold;
}

.retry-btn:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}
</style>